import axios from '../../../axios';
import { PlacementStage } from '../types/PlacementStage';

const url = '/invoicingservice/api/placement-stage';

export const getPlacementStage = () => axios.get<PlacementStage>(url);

export const savePlacementStage = (body: PlacementStage) => axios.post<PlacementStage>(url, body);
